import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {selectIsInGame, selectPlayer} from "../../../store/player/selectors";
import {selectIsLoggedIn, selectSessionUser} from "../../../store/authentication/selectors";
import * as io from "socket.io-client";
import constants from "../../../config/constants";
import Box from "@mui/material/Box";
import axios from "axios";
import {updateGameStatus} from "../../../store/player/actions";
import TableContainer from "@mui/material/TableContainer";
import {Paper} from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Button from "@mui/material/Button";
import {JoinLobbyPage} from "../game-generator/JoinLobby";

export const GamesSnippet = ({displayEvenIfEmpty}) => {

    const history = useHistory();
    const dispatch = useDispatch();

    const user = useSelector(selectSessionUser);
    const isInGame = useSelector(selectIsInGame);

    const hardcodedGames = ["terraforming", "megawatt", "throughTheAges", "sevenWonders", "heliopolis", "arknova"];
    const hardcodedGameNames = {
        "terraforming": "Terraforming Mars",
        "megawatt": "Megawatt",
        "throughTheAges": "Through the Ages",
        "sevenWonders": "7 Wonders",
        "heliopolis": "Heliopolis",
        "arknova": "Ark Nova"
    }

    const [gameList, setGameList] = useState([]);
    const [bgxLobbies, setBgxLobbies] = useState([]);
    let socketTerraforming;

    function handleConnect(game) {
        if (hardcodedGames.indexOf(game.game) > -1) {
            history.push("/" + game.game + "/" + game.lobbyId);
        } else {
            // dispatch(connectGame(game, player));
            history.push("/generated/" + game.game + "/" + game.lobbyId);
        }
    }


    useEffect(() => {
        socketTerraforming = io.connect(constants.api.socketPath, {transports: ['websocket']});
        socketTerraforming.on('games', function (data) {
            setGameList(data.games);
        });
        socketTerraforming.on('bgx-lobbies', function (data) {
            setBgxLobbies(data);
        })
        socketTerraforming.connect();
        return () => {
            socketTerraforming.close();
            console.log("closing socket");
        }
    }, []);

    useEffect(() => {
        if (user) {
            dispatch(updateGameStatus(user));
        }
    }, [user]);


    if (gameList.length === 0 && bgxLobbies.length === 0 && !displayEvenIfEmpty) {
        return undefined;
    }

    return (
        <div>
            {
                bgxLobbies.length > 0 ?
                    <JoinLobbyPage/> :
                    undefined
            }
            {
                gameList.length > 0 || displayEvenIfEmpty ?
                    <div>
                        <h2>
                            Availables games
                        </h2>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="col-xs-4">Game</TableCell>
                                        <TableCell className="col-xs-3">Host</TableCell>
                                        <TableCell className="col-xs-2"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className="bodyAvailablesGames">
                                    {
                                        gameList.length > 0 ?
                                            gameList.map((game, index) => (
                                                <TableRow key={"table-game-" + index}>
                                                    <TableCell className="col-xs-4"
                                                               style={{"verticalAlign": "middle"}}>
                                                        {
                                                            hardcodedGames.indexOf(game.game) > -1 ?
                                                                <img
                                                                    style={{height: "40px", width: "auto"}}
                                                                    src={"../../../public/images/" + game.game + ".png"}/> :
                                                                <img
                                                                    style={{height: "40px", width: "auto"}}
                                                                    src={`${constants.api.basePath}/generated/${game.game}/image?imagePath=loading/logo_title_image.png`}/>
                                                        }
                                                    </TableCell>
                                                    <TableCell className="col-xs-3"
                                                               style={{"verticalAlign": "middle"}}>
                                                        {
                                                            hardcodedGames.indexOf(game.game) > -1 ?
                                                                hardcodedGameNames[game.game] :
                                                                game.gameName
                                                        }
                                                    </TableCell>
                                                    <TableCell className="col-xs-2"
                                                               style={{"verticalAlign": "middle"}}>
                                                        {
                                                            isInGame ?
                                                                <Button disabled variant="contained">
                                                                    Join
                                                                </Button> :
                                                                <Button variant="contained"
                                                                        onClick={() => handleConnect(game)}>
                                                                    Join
                                                                </Button>
                                                        }

                                                    </TableCell>
                                                </TableRow>
                                            )) :
                                            <TableRow>
                                                <TableCell colSpan="4" style={{"verticalAlign": "middle"}}>
                                                    No game found
                                                </TableCell>
                                            </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div> : undefined
            }
        </div>
    )

}